import styled from "styled-components";
import { breakpoints } from "styles/constants/breakpoints";

export const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.white};
  padding: 40px 0;
  display: flex;
  gap: 50px;
  position: relative;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
export const WrapperContainer = styled.div`
  width: 1080px;
  height: 496px;
  overflow: hidden;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  background-color: #1e5af6;
  @media ${breakpoints.mobile} {
    width: 90%;
    height: 100%;
    flex-direction: column-reverse;
    margin-left: 20px;
    margin-right: 20px;
  }
`;
export const LeftWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  transform: translate(-9%, 19%);
  @media ${breakpoints.mobile} {
    transform: translate(0%, 0%);
    object-fit: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const CardsWrapper = styled.div`
  width: 100%;
  height: 496px;
  left: 496px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  @media ${breakpoints.mobile} {
    margin-top: 10px;
    width: 100%;
    height: 100%;
    gap: 16px;
  }
`;
export const TitleContainer = styled.div`
  width: 100%;
  height: 100%;
  justify-content: center;
  @media ${breakpoints.mobile} {
    width: 320px;
  }
`;
export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 28px;
  font-weight: 700;
  line-height: 46px;
  text-align: left;
  color: white;
  @media ${breakpoints.mobile} {
    line-height: 28px;
    font-size: ${({ theme }) => theme.fontSizes["sxl"]};
    margin: 0;
    width: 100%;
  }
`;

export const CardSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  position: relative;
  width: 600px;
  @media ${breakpoints.mobile} {
    gap: 16px;
    width: 100%;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 4px 8px rgba(0, 0, 0, 0.05),
    0 8px 16px rgba(0, 0, 0, 0.03);
  background-color: white;
  width: 520px;
  height: 80px;
  padding: 10px 10px 10px 20px;
  border-radius: 16px;
  @media ${breakpoints.mobile} {
    padding: 16px;
    width: 100%;
    min-height: fit-content;
  }
`;

export const CardTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  line-height: 30px;
  font-weight: 100;
  text-align: left;
  margin: 0;
  color: #181b25;
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    line-height: 22px;
  }
`;

export const RightWrapper = styled.div`
  @media ${breakpoints.mobile} {
    padding: 15px;
  }
`;
